import { render, staticRenderFns } from "./validSet.vue?vue&type=template&id=1e35b9c7&scoped=true&"
import script from "./validSet.vue?vue&type=script&lang=js&"
export * from "./validSet.vue?vue&type=script&lang=js&"
import style0 from "./validSet.vue?vue&type=style&index=0&id=1e35b9c7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e35b9c7",
  null
  
)

export default component.exports